<template>
  <v-layout row wrap justify-center>
    <v-flex xs12 sm11 md9>
      <v-form>
        <v-card>
          <v-card-title class="subheading py-2">PENGATURAN PROFIL</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap>
              <v-flex
                xs12
                sm5
                md4
                style="padding-bottom: 10px"
                :style="{
                  'padding-right': $vuetify.breakpoint.xs ? '0' : '10px'
                }"
              >
                <picture-input
                  v-if="editting"
                  ref="pictureInput"
                  :zIndex="0"
                  :alertOnError="false"
                  :customStrings="c.VUE_PICTURE_INPUT"
                  :prefill="c.PHOTO_PROFIL_URL + form.photo_profil"
                  :hideChangeButton="!editting"
                  :changeOnClick="false"
                  width="500"
                  height="500"
                  accept="image/jpeg,image/jpg,image/png"
                  button-class="v-btn primary v-btn--small"
                  size="10"
                  @change="onChange"
                  @error="onError"
                >
                </picture-input>
                <div v-else class="thumbnail viewer" v-viewer>
                  <img
                    v-lazy="c.PHOTO_PROFIL_URL + form.photo_profil"
                    alt="Photo profil"
                  />
                  <v-chip>
                    {{
                      $moment(
                        form.last_activity,
                        "YYYY-MM-DD HH:mm:ss",
                        true
                      ).isValid()
                        ? form.last_activity
                        : "belum pernah" | moment("from", "now")
                    }}
                  </v-chip>
                </div>
              </v-flex>
              <v-flex xs12 sm7 md8>
                <v-text-field
                  append-icon="person"
                  type="text"
                  :disabled="!editting"
                  v-model="form.username"
                  v-validate="'required'"
                  name="username"
                  data-vv-name="username"
                  label="Username"
                  data-vv-as="Username"
                  :error-messages="errors.collect('username')"
                >
                </v-text-field>
                <v-text-field
                  append-icon="mail"
                  type="text"
                  :disabled="!editting"
                  v-model="form.email"
                  v-validate="'email'"
                  name="email"
                  data-vv-name="email"
                  label="E-Mail"
                  data-vv-as="E-Mail"
                  :error-messages="errors.collect('email')"
                >
                </v-text-field>
                <v-select
                  append-icon="gavel"
                  attach
                  item-value="id_role"
                  item-text="role"
                  :items="role"
                  disabled
                  v-model="form.id_role"
                  v-validate="'required'"
                  name="id_role"
                  data-vv-name="id_role"
                  label="Role"
                  data-vv-as="Role"
                  :error-messages="errors.collect('id_role')"
                >
                  <template slot="selection" slot-scope="data">
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        data.item.role
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{
                        data.item.role_desc
                      }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-select>
                <v-btn
                  :color="fieldPassword ? 'secondary' : 'primary'"
                  class="mx-0 mt-0 mb-2"
                  @click="toggleFieldPassword"
                  :disabled="!editting"
                  :dark="editting"
                  small
                  >{{ fieldPassword ? "BATALKAN" : "" }} RESET PASSWORD</v-btn
                >
                <v-text-field
                  v-if="fieldPassword"
                  :disabled="!editting"
                  :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon-cb="() => (showPassword = !showPassword)"
                  hint="*Password harus mengandung Huruf besar, Huruf kecil, Angka, dan Simbol"
                  persistent-hint
                  v-model="form.password"
                  v-validate="'required|min:8|max:10|valid_password'"
                  name="password"
                  data-vv-name="password"
                  label="Password"
                  data-vv-as="Password"
                  :error-messages="errors.collect('password')"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn v-if="!editting" dark color="primary" @click="edit"
              >EDIT</v-btn
            >
            <template v-else>
              <v-btn
                color="primary"
                type="submit"
                :dark="!sameForm"
                :disabled="sameForm"
                @click.prevent="submit"
                >SIMPAN
              </v-btn>
              <v-btn @click="reset"> BATAL</v-btn>
            </template>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</template>


<script>
import _ from "lodash";
import c from "@/constants";
import PictureInput from "@/components/widgets/input/PictureInput";
import { mapState } from "vuex";

export default {
  name: "profil",
  components: {
    PictureInput
  },
  data() {
    return {
      form: _.cloneDeep(this.$store.state.auth.profil),
      c: c,
      editting: false,
      showPassword: false,
      fieldPassword: false,
      image: ""
      // prefillOptions: {
      //   mediaType: "image/png"
      // }
    };
  },
  computed: {
    ...mapState(["status"]),
    ...mapState("user", ["role"]),
    ...mapState("auth", ["profil"]),
    storeData() {
      return _.cloneDeep(this.profil);
    },
    sameForm() {
      let temp = _.cloneDeep(this.profil);
      temp.password = "";
      return _.isEqual(temp, this.form) && !this.image;
    }
  },
  watch: {
    storeData(newValue) {
      this.form = newValue;
    }
  },
  methods: {
    onChange() {
      if (this.$refs.pictureInput.file) {
        this.image = this.$refs.pictureInput.file;
      } else {
        this.$store.commit(
          "ERROR",
          "FileReader API tidak didukung, gunakan browser terbaru."
        );
      }
    },
    onError(e) {
      this.$store.commit("ERROR", e.message);
    },
    toggleFieldPassword() {
      this.fieldPassword = !this.fieldPassword;
      if (this.fieldPassword) this.form.password = "";
    },
    edit() {
      this.editting = !this.editting;
      this.form.password = "";
    },
    reset() {
      this.$validator.reset();
      this.editting = false;
      this.fieldPassword = false;
      this.image = "";
      this.form = _.cloneDeep(this.profil);
    },
    submit() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store
            .dispatch("auth/UPDATE_PROFIL", {
              form: this.form,
              image: this.image
            })
            .then(() => {
              this.reset();
            })
            .catch();
        } else {
          this.$store.commit(
            "ERROR",
            "Ada field yang masih error, cek kembali isian form!"
          );
        }
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.thumbnail {
  position: relative;
  width: 100%;
  height: 220px;
  overflow: hidden;
  background-color: grey;
}
.thumbnail img {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
